import RouterLayout from "../../components/[city]/_routerLayout";

export default function NieruchomosciLayout() {
	return <RouterLayout Podatek="nieruchomosci" />;
}

export async function getServerSideProps(context) {
	const { query, req } = context;

	const SOPOT_ID = "3340a524-ab25-4c19-9380-34b610cb979b";

	if (query.siteCode === SOPOT_ID) {
		const host = req.headers.host;

		let protocol = "http";
		if (req.headers["x-forwarded-proto"]) {
			protocol = req.headers["x-forwarded-proto"];
		} else if (host.includes("localhost")) {
			protocol = "http";
		} else {
			protocol = "https";
		}

		const absoluteUrl = `${protocol}://${host}/sopot/podatek-od-nieruchomosci/`;

		return {
			redirect: {
				destination: absoluteUrl,
				permanent: true,
			},
		};
	}

	return {
		props: {},
	};
}
